import React, { FC, useEffect, useState } from "react";
import {
  Col,
  Modal,
  Result,
  Row,
  Select,
  Image,
  Button,
  Spin,
  Input,
  Form,
  notification,
  Badge,
  Tooltip,
} from "antd";
import styled from "styled-components";
import { NavLink, useHistory } from "react-router-dom";
import { Text3D } from "../../../Components/Text3D";
import { useMutation, useQuery } from "@apollo/client";
import { MY_ORDERS_V2 } from "../../../Apollo/graphql/Query";
import { getUserData } from "../../../utils/utilsFunctions";
import { UPDATE_ORDER_V2 } from "../../../Apollo/graphql/Mutation/OrderMutations/EditOrder";
import { DOWNLOAD_DESIGN_V2 } from "../../../Apollo/graphql/Mutation/DownloadDesign";
import FullHeightLoader from "../../../Components/FullHeightLoader";
import { CloudDownloadOutlined, MessageOutlined } from "@ant-design/icons";
import NullDataComp from "../../../Components/NullDataComp";
import { replaceError } from "../../../utils/utilsFunctions";
import moment from "moment";
import RatePrinterModal from "../../../Components/RatePrinterModal";
const { Option } = Select;

const OrderContainer = styled(Row)`
  /* &:before {
    content: "";
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 20px solid white;
    margin-left: 25px;
  } */
`;
const OrderContent = styled(Col)`
  // background: white;
  width: 100%;
`;

const Order = styled.div`
  background-color: #ffffff;
  padding: 12px;
  margin-bottom: 12px;
  .order-info-main {
    border-bottom: 1px solid #dadada;
    .order-total-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
  }
  .order-package {
    margin-top: 12px;
    .package-seller {
      margin-bottom: 8px;
    }
    .package-status-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
    .package-price-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }
    .status-price-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      div {
        text-align: right;
      }
    }
    .single-item-wrapper {
      margin-bottom: 16px;
    }
  }
`;

const STATUS_COLOR = {
  PENDING_PAYMENT: "#d9d9d9",
  CONFIRMED: "#ff4d4f",
  PREPARED: "#faad14",
  RECEIVED: "#52c41a",
  DELIVERED: "#1890ff",
  DEFAULT: "#d9d9d9",
};

const OrderPageNew: FC = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [currentProcessTitle, setCurrentProcessTitle] = useState<any>(null);
  const [currentOrder, setCurrentOrder] = useState<any>({});
  const [updateOrderV2] = useMutation(UPDATE_ORDER_V2);
  const [downloadDesignMutation] = useMutation(DOWNLOAD_DESIGN_V2);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isUpdateShippingModalVisible, setIsUpdateShippingModalVisible] =
    useState(false);
  const [selectedPrinter, setSelectedPrinter] = useState(null);

  const [form] = Form.useForm();
  const user = JSON.parse(getUserData("user"));

  // console.log("current order", currentOrder);

  // redirecting url check after order payment action
  const url = window.location.href;
  const resString = url.split("?")[1];
  const success = resString === "success";
  const failed = resString === "failed";

  const { loading: orderLoading, data: ordersData } = useQuery(MY_ORDERS_V2, {
    variables: {
      pagination: {
        page: 1,
        limit: 100,
      },
    },
  });

  // console.log("----ORDERS DATA---", ordersData);

  useEffect(() => {
    form.setFieldsValue({
      shippingId: currentOrder.shippingId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrder]);
  const showShippingModal = () => {
    setIsUpdateShippingModalVisible(true);
  };

  const handleShippingOk = () => {
    if (!currentOrder) {
      alert("something went wrong");
    } else {
      updateOrderV2({
        variables: {
          orderId: currentOrder.orderId,
          packageId: currentOrder.packageId,
          input: {
            shippingId: currentOrder.shippingId,
          },
        },
        refetchQueries: [{ query: MY_ORDERS_V2 }],
      })
        .then((data) => {
          setCurrentOrder({});
        })
        .catch((e) => {
          setCurrentOrder({});
        });
    }
    setIsUpdateShippingModalVisible(false);
  };

  const handleShippingCancel = () => {
    setCurrentOrder({});
    setIsUpdateShippingModalVisible(false);
  };

  useEffect(() => {
    if (success) {
      setIsModalVisible(true);
    }
  }, [success]);

  useEffect(() => {
    if (failed) {
      setIsModalVisible(true);
    }
  }, [failed]);
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const onDownloadClick = async (id: any) => {
    try {
      setLoading(true);
      setCurrentProcessTitle("File Downloading...");
      const {
        data: { downloadDesignV2: presignedUrls },
      }: any = await downloadDesignMutation({
        variables: { designId: id },
      });

      if (presignedUrls) {
        // eslint-disable-next-line array-callback-return
        presignedUrls.map((url, index) => {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${id}_${index}.stl`); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      }
      setLoading(false);
      setCurrentProcessTitle("");
      notification.success({
        message: "Downloading ...",
        description:
          "Your download has started, check your downloads in browser",
      });
    } catch (err) {
      setLoading(false);
      setCurrentProcessTitle("");
      notification.error({
        message: "Error",
        description: replaceError(err),
      });
    }
  };

  const editUpdateOrder = async (key, orderId, packageId) => {
    try {
      setLoading(true);
      await updateOrderV2({
        variables: {
          orderId: orderId,
          packageId: packageId,
          input: {
            status: key,
          },
        },
      });
      setLoading(false);
      notification.success({
        message: "Success",
        description: "Package status updated",
      });
    } catch (e) {
      setLoading(false);
      notification.error({
        message: "Error",
        description: replaceError(e),
      });
    }
  };

  return (
    <Spin spinning={loading} tip={currentProcessTitle}>
      <OrderContainer>
        <OrderContent>
          {success && (
            <Modal
              visible={isModalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
            >
              <Result
                status="success"
                title=" Order received successfully and payment has been processed!"
                subTitle="Please check your order status in this page."
              />
            </Modal>
          )}
          {failed && (
            <Modal
              visible={isModalVisible}
              onOk={handleOk}
              okText="Try Again"
              onCancel={handleCancel}
            >
              <Result
                status="error"
                title="Payment failed with your recent order!"
              />
            </Modal>
          )}

          {orderLoading && <FullHeightLoader />}
          {ordersData?.myOrdersV2?.orders &&
            ordersData.myOrdersV2.orders.length === 0 && <NullDataComp />}
          {ordersData?.myOrdersV2?.orders &&
            ordersData.myOrdersV2.orders.map((order: any) => {
              return (
                <Order>
                  <div className="order-info">
                    <div className="order-info-main">
                      <Row>
                        <Col span={12}>
                          <div>
                            <Text3D textSize="0.9rem" textWeight={600}>
                              Order No. {order.platformOrderNo}
                            </Text3D>
                          </div>
                          <Text3D textSize="0.8rem" textWeight={300}>
                            Placed on{" "}
                            {`${moment(order?.createdAt).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )}`}
                          </Text3D>
                        </Col>
                        <Col span={12}>
                          {order.requestedByUserId === user._id && (
                            <div className="order-total-wrapper">
                              <Text3D
                                textWeight={600}
                                textSize="0.9rem"
                                style={{ marginRight: "8px" }}
                              >
                                Total:
                              </Text3D>
                              <Text3D
                                textSize="0.9rem"
                                textWeight={600}
                                textColor="#1196DD"
                              >
                                AU$ {order.grossTotal}
                              </Text3D>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                  {order.packages.map((singlePackage, pdx) => {
                    return (
                      <div className="order-package">
                        <Row>
                          <Col md={7} xs={12}>
                            <div className="package-seller">
                              <div>
                                <Text3D textSize="0.8rem" textWeight={600}>
                                  Package: {pdx + 1}
                                </Text3D>
                              </div>
                              <div>
                                <Text3D textSize="0.8rem" textWeight={600}>
                                  Seller:{" "}
                                  {`${
                                    singlePackage.requestedForUser.firstName
                                  } ${
                                    singlePackage.requestedForUser.lastName ||
                                    ""
                                  }`}
                                </Text3D>
                              </div>
                              {singlePackage.items[0].status !==
                                "PENDING_PAYMENT" && (
                                <div>
                                  <Button
                                    type="primary"
                                    shape="round"
                                    size="small"
                                    icon={
                                      <MessageOutlined
                                        style={{
                                          fontSize: "1rem",
                                        }}
                                      />
                                    }
                                    style={{ fontWeight: "bold" }}
                                    onClick={() =>
                                      history.push("/dashboard/inbox")
                                    }
                                  >
                                    Chat
                                  </Button>
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col md={5} xs={12}>
                            <div className="package-type">
                              <div>
                                <Text3D textSize="0.9rem" textWeight={600}>
                                  Delivery Type: {singlePackage.deliveryType}
                                </Text3D>
                              </div>
                              {singlePackage.deliveryType === "SHIPPING" && (
                                <div>
                                  <Text3D textSize="0.9rem" textWeight={600}>
                                    Shipping Type:{" "}
                                    {order.shippingDetail &&
                                      order.shippingDetail.postServiceCode &&
                                      (
                                        order.shippingDetail.postServiceCode ||
                                        ""
                                      ).replaceAll("AUS_PARCEL_", "")}
                                  </Text3D>
                                </div>
                              )}
                              {singlePackage.deliveryType &&
                                singlePackage.deliveryType === "PICKUP" && (
                                  <div>
                                    <Text3D textSize="0.9rem" textWeight={600}>
                                      Pickup Location:{" "}
                                      {singlePackage.shippingDetail.fromLocation
                                        ? `${
                                            singlePackage.shippingDetail
                                              .fromAddress || "-"
                                          },${
                                            singlePackage.shippingDetail.from ||
                                            "-"
                                          },${
                                            singlePackage.shippingDetail
                                              .fromLocation || ""
                                          },${
                                            singlePackage.shippingDetail
                                              .fromState || ""
                                          },${
                                            singlePackage.shippingDetail
                                              .countryCode || ""
                                          }`
                                        : singlePackage.items[0]?.printer
                                            ?.postalAddress || ""}
                                    </Text3D>
                                  </div>
                                )}
                              {singlePackage.deliveryType &&
                                singlePackage.deliveryType === "SHIPPING" && (
                                  <div>
                                    <Text3D textSize="0.9rem" textWeight={600}>
                                      Ship to:{" "}
                                      {`${order.shippingDetail.to || "-"}, ${
                                        order.shippingDetail.deliveryLocation ||
                                        "-"
                                      }, ${
                                        order.shippingDetail.deliveryAddress ||
                                        "-"
                                      }, ${
                                        order.shippingDetail.deliveryState ||
                                        "-"
                                      }, ${
                                        order.shippingDetail.overseas
                                          ? order.shippingDetail.countryCode ||
                                            ""
                                          : "AU"
                                      }`}
                                      <br />
                                      Ship From: {""}
                                      {singlePackage.shippingDetail.fromLocation
                                        ? `${
                                            singlePackage.shippingDetail
                                              .fromAddress || "-"
                                          },${
                                            singlePackage.shippingDetail.from ||
                                            "-"
                                          },${
                                            singlePackage.shippingDetail
                                              .fromLocation || ""
                                          },${
                                            singlePackage.shippingDetail
                                              .fromState || ""
                                          },${
                                            singlePackage.shippingDetail
                                              .countryCode || ""
                                          }`
                                        : singlePackage.items[0]?.printer
                                            ?.postalAddress || ""}
                                    </Text3D>
                                  </div>
                                )}
                            </div>
                          </Col>
                          <Col md={12} xs={24}>
                            <div className="package-status-wrapper">
                              {singlePackage.deliveryType &&
                                singlePackage.deliveryType !== "PICKUP" && (
                                  <>
                                    <div style={{ marginRight: "6px" }}>
                                      <Text3D
                                        textSize="0.8rem"
                                        textWeight={600}
                                      >
                                        Tracking No:
                                      </Text3D>
                                      <Text3D
                                        textSize="0.8rem"
                                        textWeight={600}
                                      >
                                        {singlePackage.shippingId || " Not Set"}
                                      </Text3D>
                                    </div>
                                    <div style={{ marginRight: "14px" }}>
                                      {order?.requestedByUserId !==
                                        user._id && (
                                        <Button
                                          type="text"
                                          disabled={
                                            singlePackage?.requestedForUserId !==
                                            user._id
                                          }
                                          style={{ fontWeight: 700 }}
                                          onClick={() => {
                                            setCurrentOrder({
                                              orderId: order?._id,
                                              packageId: singlePackage._id,
                                              shippingId:
                                                singlePackage?.shippingId,
                                            });
                                            showShippingModal();
                                          }}
                                        >
                                          Edit
                                        </Button>
                                      )}
                                    </div>
                                  </>
                                )}
                              <div>
                                <Text3D textSize="0.8rem" textWeight={600}>
                                  Package Status{" "}
                                </Text3D>
                              </div>
                              <div>
                                <Select
                                  value="Manage"
                                  style={{ width: 120 }}
                                  onSelect={(key) =>
                                    editUpdateOrder(
                                      key,
                                      order._id,
                                      singlePackage._id
                                    )
                                  }
                                >
                                  {singlePackage.requestedForUserId ===
                                    user._id &&
                                  singlePackage.items[0].status ===
                                    "CONFIRMED" ? (
                                    <>
                                      <Option value="PREPARED">PREPARED</Option>
                                      <Option value="DELIVERED">
                                        DELIVERED
                                      </Option>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  {singlePackage.requestedForUserId ===
                                    user._id &&
                                  singlePackage.items[0].status ===
                                    "PREPARED" ? (
                                    <Option value="DELIVERED">DELIVERED</Option>
                                  ) : (
                                    ""
                                  )}
                                  {order.requestedByUserId === user._id &&
                                  singlePackage.items[0].status ===
                                    "DELIVERED" ? (
                                    <>
                                      <Option value="RECEIVED">RECEIVED</Option>
                                    </>
                                  ) : (
                                    " "
                                  )}
                                </Select>
                              </div>
                            </div>
                            {singlePackage.requestedForUserId === user._id && (
                              <div className="package-price-wrapper">
                                <Text3D
                                  textSize="0.9rem"
                                  textWeight={600}
                                  style={{ marginRight: "8px" }}
                                >
                                  Total
                                </Text3D>
                                <Text3D
                                  textSize="0.9rem"
                                  textWeight={600}
                                  textColor="#1196DD"
                                >
                                  AU$ {singlePackage.grossSellerTotal}
                                </Text3D>
                              </div>
                            )}
                          </Col>
                        </Row>
                        {singlePackage.items.map((item, idx) => {
                          return (
                            <div className="order-item">
                              <Row>
                                <Col span={24}>
                                  <div
                                    className="single-item-wrapper"
                                    key={idx}
                                  >
                                    <Row>
                                      <Col md={7} xs={12}>
                                        {item.design &&
                                          item.design.featuredImage && (
                                            <Image
                                              src={item.design.featuredImage}
                                              style={{
                                                height: "110px",
                                                width: "auto",
                                              }}
                                            />
                                          )}
                                      </Col>
                                      <Col md={9} xs={12}>
                                        <div>
                                          <div>
                                            <Text3D
                                              textWeight={600}
                                              textSize="1rem"
                                            >
                                              Design:{" "}
                                              {item.design && item.design.name}
                                            </Text3D>
                                            <Button
                                              style={{
                                                border: "none",
                                                marginRight: "8px",
                                              }}
                                            >
                                              <Tooltip title="Download design">
                                                <CloudDownloadOutlined
                                                  onClick={() =>
                                                    onDownloadClick(
                                                      item.designId
                                                    )
                                                  }
                                                  style={{
                                                    fontSize: "1.2rem",
                                                  }}
                                                />
                                              </Tooltip>
                                            </Button>
                                          </div>
                                          <div>
                                            <Text3D
                                              textWeight={600}
                                              textSize="1rem"
                                            >
                                              Printer:{" "}
                                            </Text3D>
                                            <NavLink
                                              to={`/printers/${item.printerId}`}
                                            >
                                              {item?.printer?.name || ""}
                                            </NavLink>
                                            <div>
                                              <Button
                                                type="default"
                                                shape="round"
                                                size="small"
                                                style={{ fontWeight: "bold" }}
                                                onClick={() =>
                                                  setSelectedPrinter(
                                                    item?.printer
                                                  )
                                                }
                                              >
                                                Rate this printer
                                              </Button>
                                            </div>
                                          </div>
                                        </div>
                                      </Col>
                                      <Col md={8} xs={24}>
                                        <Row>
                                          <Col span={12}>
                                            <div>
                                              <div>
                                                <span>Quantity: </span>
                                                <span>{item.quantity}</span>
                                              </div>
                                              <div>
                                                <span>Infill: </span>
                                                <span>{item.infill}</span>
                                              </div>
                                              <div>
                                                <span>Scale: </span>
                                                <span>{item.scale}</span>
                                              </div>
                                              <div>
                                                <span>Material: </span>
                                                <span>{item.material}</span>
                                              </div>
                                              <div>
                                                <span>Color: </span>
                                                <span>{item.color}</span>
                                              </div>
                                            </div>
                                          </Col>
                                          <Col span={12}>
                                            <div className="status-price-wrapper">
                                              <div>
                                                <Badge
                                                  count={item.status}
                                                  style={{
                                                    backgroundColor:
                                                      STATUS_COLOR[
                                                        item.status
                                                      ] ||
                                                      STATUS_COLOR["DEFAULT"],
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </Order>
              );
            })}
          <Modal
            visible={isUpdateShippingModalVisible}
            onOk={handleShippingOk}
            onCancel={handleShippingCancel}
          >
            <Form form={form} labelCol={{ span: 24 }} autoComplete="off">
              <Form.Item label="Tracking No" name="shippingId">
                <Input
                  onChange={(e) =>
                    setCurrentOrder({
                      ...currentOrder,
                      shippingId: e.target.value,
                    })
                  }
                />
              </Form.Item>
            </Form>
          </Modal>
        </OrderContent>
      </OrderContainer>
      {selectedPrinter && (
        <RatePrinterModal
          isRatePrinterVisible={!!selectedPrinter}
          printer={selectedPrinter}
          handleClose={() => setSelectedPrinter(null)}
        />
      )}
    </Spin>
  );
};

export default OrderPageNew;
